var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_2119)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54_2119",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 11H11V29H29V11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54_2119)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4134 11.5847C11.4764 11.4563 11.607 11.375 11.75 11.375H15.5C15.6161 11.375 15.7257 11.4288 15.7967 11.5207L28.5467 28.0207C28.6341 28.1339 28.6497 28.2869 28.5866 28.4153C28.5236 28.5436 28.393 28.625 28.25 28.625H24.5C24.3839 28.625 24.2743 28.5712 24.2033 28.4793L11.4533 11.9793C11.3658 11.8661 11.3504 11.7131 11.4134 11.5847ZM12.5137 12.125L24.6841 27.875H27.4864L15.3159 12.125H12.5137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5152 11.4848C28.6616 11.6313 28.6616 11.8687 28.5152 12.0152L21.3902 19.1402C21.2437 19.2866 21.0063 19.2866 20.8598 19.1402C20.7134 18.9937 20.7134 18.7563 20.8598 18.6098L27.9848 11.4848C28.1313 11.3384 28.3687 11.3384 28.5152 11.4848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5152 11.4848C28.6616 11.6313 28.6616 11.8687 28.5152 12.0152L21.3902 19.1402C21.2437 19.2866 21.0063 19.2866 20.8598 19.1402C20.7134 18.9937 20.7134 18.7563 20.8598 18.6098L27.9848 11.4848C28.1313 11.3384 28.3687 11.3384 28.5152 11.4848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5152 11.4848C28.6616 11.6313 28.6616 11.8687 28.5152 12.0152L21.3902 19.1402C21.2437 19.2866 21.0063 19.2866 20.8598 19.1402C20.7134 18.9937 20.7134 18.7563 20.8598 18.6098L27.9848 11.4848C28.1313 11.3384 28.3687 11.3384 28.5152 11.4848ZM11.4848 28.5152C11.3384 28.3687 11.3384 28.1313 11.4848 27.9848L18.6098 20.8598C18.7563 20.7134 18.9937 20.7134 19.1402 20.8598C19.2866 21.0063 19.2866 21.2437 19.1402 21.3902L12.0152 28.5152C11.8687 28.6616 11.6313 28.6616 11.4848 28.5152Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_2119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b20d415ea945577b6140d00b0f2b4cad.svg";
export { ForwardRef as ReactComponent };